import { render, staticRenderFns } from "./WidgetEmployeePerformanceStats.vue?vue&type=template&id=42636e54&scoped=true&"
import script from "./WidgetEmployeePerformanceStats.vue?vue&type=script&lang=js&"
export * from "./WidgetEmployeePerformanceStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42636e54",
  null
  
)

export default component.exports